import React, { useRef, useState } from 'react';
import { CctvResponse } from '../../../../../../../modules/maps';
import { StyledCctvWrapper } from './style.ts';
import CircularProgress from '@mui/material/CircularProgress';

interface IProps {
  cctv: CctvResponse;
  onClose?: () => void;
  index?: number;
  zIndex?: number;
  isFocused?: boolean;
  onFocus?: () => void;
}

const CASCADE_OFFSET = 30;

export const CctvWrapper: React.FC<IProps> = ({ cctv, onClose, index = 0, zIndex = 20, isFocused = true, onFocus }) => {
  const [pos, setPos] = useState({ x: -(index * CASCADE_OFFSET), y: index * CASCADE_OFFSET });
  const [dragging, setDragging] = useState(false);
  const [loading, setLoading] = useState(true);

  const startRef = useRef<{ startX: number; startY: number; baseX: number; baseY: number } | null>(
    null
  );

  const onPointerDownHandle: React.PointerEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.currentTarget.setPointerCapture(e.pointerId);
    startRef.current = { startX: e.clientX, startY: e.clientY, baseX: pos.x, baseY: pos.y };
    setDragging(true);
  };

  const onPointerMoveHandle: React.PointerEventHandler<HTMLDivElement> = (e) => {
    if (!startRef.current) return;
    setPos({
      x: startRef.current.baseX + (e.clientX - startRef.current.startX),
      y: startRef.current.baseY + (e.clientY - startRef.current.startY)
    });
  };

  const onPointerUpHandle: React.PointerEventHandler<HTMLDivElement> = (e) => {
    startRef.current = null;
    setDragging(false);
    (e.currentTarget as HTMLDivElement).releasePointerCapture?.(e.pointerId);
  };

  return (
    <StyledCctvWrapper
      className={dragging ? 'dragging' : ''}
      style={{ transform: `translate3d(${pos.x}px, ${pos.y}px, 0)`, zIndex }}
      onPointerDown={onFocus}
    >
      <div
        className="title-bar"
        onPointerDown={onPointerDownHandle}
        onPointerMove={onPointerMoveHandle}
        onPointerUp={onPointerUpHandle}
        onPointerCancel={onPointerUpHandle}
      >
        <span className="title-text">{cctv.cctvName}</span>
        <button
          className="close-btn"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            onClose?.();
          }}
        >
          ✕
        </button>
      </div>
      <div className="cctv-frame-wrapper">
        {loading && (
          <div className="cctv-loading">
            <CircularProgress size={36} thickness={4} style={{ color: '#555' }} />
          </div>
        )}
        <iframe
          src={cctv.originalUrl}
          className="cctv-frame"
          allow="autoplay; fullscreen"
          allowFullScreen
          onLoad={() => setLoading(false)}
          style={{ visibility: loading ? 'hidden' : 'visible' }}
        />
        {!isFocused && (
          <div
            style={{ position: 'absolute', inset: 0, zIndex: 1, cursor: 'pointer' }}
            onPointerDown={() => onFocus?.()}
          />
        )}
      </div>
    </StyledCctvWrapper>
  );
};
